import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';
import { NAV_GROUPS } from '../config/navConfig';
import SidebarGroup from './SidebarGroup';

// Desktop-only collapsible left rail. Icon-only when collapsed, icon+label+grouped
// sections when expanded. Collapse state persisted via useSidebarCollapsed (AppLayout).
export default function Sidebar({ collapsed, onToggleCollapsed, accessibleItems, badgeValues, logoUrl }) {
  const alwaysItems = accessibleItems.filter(i => i.group === 'always');

  return (
    <div
      className="app-chrome d-none d-lg-flex flex-column"
      style={{
        position: 'fixed', top: 0, left: 0, bottom: 0,
        width: collapsed ? 'var(--sidebar-width-collapsed)' : 'var(--sidebar-width-expanded)',
        background: 'var(--sidebar-bg)',
        zIndex: 1000,
        transition: 'width 0.15s ease',
        overflow: 'hidden',
      }}
    >
      {/* Logo */}
      <Link
        to="/" /* RootRedirect sends each role to its own home */
        className="d-flex align-items-center text-decoration-none text-white"
        style={{ height: 'var(--topbar-height)', flexShrink: 0, padding: collapsed ? '0' : '0 16px', justifyContent: collapsed ? 'center' : 'flex-start', borderBottom: '1px solid rgba(255,255,255,0.08)' }}
      >
        {logoUrl
          ? <img src={logoUrl} alt="Company Logo" style={{ height: 28, width: 28, objectFit: 'contain' }} />
          : <span style={{ fontSize: 18, fontWeight: 700 }}>{collapsed ? 'qL' : 'quickLOG'}</span>}
        {!collapsed && logoUrl && <span className="ms-2" style={{ fontSize: 16, fontWeight: 600 }}>quickLOG</span>}
      </Link>

      {/* Scrollable nav */}
      <div className="flex-fill" style={{ overflowY: 'auto', overflowX: 'hidden', padding: '8px 0' }}>
        <SidebarGroup group={null} items={alwaysItems} collapsed={collapsed} badgeValues={badgeValues} />
        {NAV_GROUPS.map(group => (
          <SidebarGroup
            key={group.key}
            group={group}
            items={accessibleItems.filter(i => i.group === group.key)}
            collapsed={collapsed}
            badgeValues={badgeValues}
          />
        ))}
      </div>

      {/* Collapse toggle */}
      <button
        className="btn d-flex align-items-center text-white-50"
        style={{ height: 44, flexShrink: 0, borderTop: '1px solid rgba(255,255,255,0.08)', borderRadius: 0, justifyContent: collapsed ? 'center' : 'flex-start', padding: collapsed ? 0 : '0 16px', gap: 8 }}
        onClick={onToggleCollapsed}
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {collapsed ? <FiChevronsRight size={16} /> : <><FiChevronsLeft size={16} /> <span style={{ fontSize: 13 }}>Collapse</span></>}
      </button>
    </div>
  );
}
